
<nb-card style="width: 60%; margin: 0 auto;">
    <nb-card-header>{{"WHAT_IS_SMART_TARIFF" | translate }}</nb-card-header>
    <nb-card-body innerHTML='{{"SMART_TARIFF_ANS" | translate}}'></nb-card-body>
    <nb-card-footer><button nbButton (click)="close()">{{"CLOSE" | translate}}</button></nb-card-footer>
</nb-card>


<!-- <h6>{{"COMPARING_HEADING" | translate }}</h6>
<span innerHTML="{{'COMPARING_CONTENT' | translate}}"></span> -->